module.exports = __webpack_public_path__ + "img/banner.d1616a53.png";